import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import React from 'react';

interface SLABadgesProps {
  withinSla: number;
  outsideSla: number;
}

export const SLABadges: React.FC<SLABadgesProps> = ({
  withinSla,
  outsideSla,
}) => {
  return (
    <div className='grid grid-cols-2 gap-4 w-full'>
      <div className='bg-white p-4 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center gap-2 group hover:border-emerald-200 transition-all'>
        <div className='flex items-center gap-2 text-emerald-600 transition-transform group-hover:scale-110'>
          <CheckCircleIcon className='!w-4 !h-4' />
          <span className='text-[10px] font-black uppercase tracking-wider'>
            A Tiempo
          </span>
        </div>
        <span className='text-3xl font-[1000] text-slate-900 tabular-nums'>
          {withinSla}
        </span>
      </div>

      <div className='bg-white p-4 rounded-2xl border border-slate-100 shadow-sm flex flex-col items-center gap-2 group hover:border-rose-200 transition-all'>
        <div className='flex items-center gap-2 text-rose-500 transition-transform group-hover:scale-110'>
          <ErrorIcon className='!w-4 !h-4' />
          <span className='text-[10px] font-black uppercase tracking-wider'>
            Excedidos
          </span>
        </div>
        <span className='text-3xl font-[1000] text-slate-900 tabular-nums'>
          {outsideSla}
        </span>
      </div>
    </div>
  );
};
